// src/plugins/i18n.js
import { ref, readonly, computed } from 'vue'

// 语言包
const messages = {
  'zh-CN': {
    'wishTree.title': '许愿树',
    'wishTree.publishWish': '发布愿望',
    'wishTree.wishContent': '愿望内容',
    'wishTree.selectStyle': '选择愿望样式',
    'wishTree.orangeWish': '橙子挂签',
    'wishTree.appleWish': '苹果挂签',
    'wishTree.crystalWish': '水晶挂签',
    'wishTree.wishPlaceholder': '写下你的愿望...',
    'wishTree.anonymous': '匿名发布',
    'wishTree.useUsername': '使用用户名',
    'wishTree.customName': '自定义名称',
    'wishTree.refresh': '换一批',
    'wishTree.noWishes': '还没有许愿，快写下你的愿望吧！',
    'wishTree.loadingWishes': '加载许愿中...',
    'wishTree.wishDetail': '愿望详情',
    'wishTree.publisher': '发布者',
    'wishTree.publishTime': '发布时间',
    'wishTree.me': '我',
    'wishTree.anonymousUser': '匿名用户',
    'common.confirm': '确定',
    'common.cancel': '取消',
    'common.save': '保存',
    'common.close': '关闭',
    'common.loading': '加载中...',
    'auth.login': '登录',
    'auth.register': '注册',
    'auth.logout': '退出登录',
    'auth.username': '用户名',
    'auth.account': '用户名/邮箱',
    'auth.password': '密码',
    'auth.email': '邮箱',
    'auth.phone': '手机号',
    'auth.verifyCode': '验证码',
    'auth.verifyCode.retry': '秒后重试',
    'auth.sendCode': '发送验证码',
    'auth.loginSuccess': '登录成功！',
    'auth.registerSuccess': '注册成功！',
    'auth.userCenter': '个人中心',
    'message.publishSuccess': '愿望发布成功！（个人发布超50条会删除自己发布的最早记录）',
    'message.publishFailed': '发布失败，请稍后重试',
    'message.loginFirst': '请先登录再发布愿望',
    'message.refreshSuccess': '已为您刷新许愿',
    'about.aboutUs': '关于我们',
    'about.contactUs': '联系我们',
    'about.privacyPolicy': '隐私政策',
    'about.userAgreement': '用户协议',
    'about.copyRight': '© 2023 许愿树网站. 保留所有权力.',
    'login.userLogin': '用户登录',
    'login.userNamePlaceholder': '请输入用户名/邮箱',
    'login.passwordPlaceholder': '请输入密码',
    'register.userRegister': '用户注册',
    'register.userNamePlaceholder': '请输入用户名',
    'register.phonePlaceholder': '请输入手机号',
    'register.emailPlaceholder': '请输入邮箱',
    'register.emailCode': '验证码',
    'register.emailCodePlaceholder': '请输入邮箱验证码',
    'register.confirmPassword': '确认密码',
    'register.confirmPasswordPlaceholder': '请再次输入密码',
    'wishTree.customNamePlaceholder': '请输入自定义名称（最多25个字符）',
    'wishTree.customNameHint': '注：自定义名称将会显示在愿望旁边，其他用户可以看到',
    'wishTree.unknownType': '未知类型',
    'validation.requiredAll': '请完成所有必填项',
    'message.editComingSoon': '编辑功能开发中...',
    'message.confirmDelete': '确定要删除这个愿望吗？',
    'message.deleteSuccess': '删除成功！',
    'policy.privacyTitle': '隐私政策',
    'policy.userAgreementTitle': '用户协议',
    'policy.agree': '同意',
    'about.aboutUsMessage': '关于我们：许愿树是一个在线愿望分享平台，让您可以表达和分享美好的愿望。',
    'about.contactUsMessage': '联系我们：如有任何问题，请发送邮件至 support@wishtree.hk',
    // 验证相关
    'validation.emailRequired': '请输入邮箱地址',
    'validation.emailFormat': '请输入正确的邮箱地址',
    'validation.verifyCodeRequired': '请输入验证码',
    'validation.verifyCodeFormat': '验证码必须是6位数字',
    'validation.passwordRequired': '请输入密码',
    'validation.passwordLength': '密码长度在6到20个字符',
    'validation.passwordPattern': '密码必须包含字母和数字',
    'validation.confirmPasswordRequired': '请再次输入密码',
    'validation.passwordMatch': '两次输入的密码不一致',
    'validation.phoneRequired': '请输入手机号',
    'validation.phoneFormat': '手机号格式不正确',
    'validation.usernameRequired': '请输入用户名',
    'validation.usernameLength': '用户名长度在3到20个字符',
    'validation.usernamePattern': '用户名只能包含字母、数字、下划线',

    // 忘记密码相关
    'auth.forgotPassword': '忘记密码',
    'auth.resetPassword': '重置密码',
    'auth.enterEmail': '请输入邮箱',
    'auth.newPassword': '新密码',
    'auth.confirmNewPassword': '确认新密码',
    'auth.forgotPasswordTitle': '忘记密码',

    // 消息提示
    'message.codeSent': '验证码已发送，请注意查收',
    'message.resetSuccess': '密码重置成功',
    'message.sendCodeFailed': '发送验证码失败',
    'message.resetFailed': '重置密码失败',
    'message.shareToXSuccess': '正在打开X分享页面...',
    'message.instagramShareHint': '分享内容已复制到剪贴板。如果Instagram应用已打开，请粘贴并分享。',
    'message.instagramAppOpening': '正在打开Instagram应用...',
    'message.instagramAppNotFound': '未检测到Instagram应用，正在跳转到应用商店...',
    'message.shareFailed': '分享失败，请稍后重试',
    'message.copySuccess': '链接已复制到剪贴板',
    'message.copyFailed': '复制失败，请手动复制',
    'message.wishNotFound': '未找到对应的愿望，可能已被刷新',

    // 分享相关
    'wishTree.shareWish': '分享愿望',
    'wishTree.shareToX': '分享到 X',
    'wishTree.shareToInstagram': '分享到 Instagram',
    'wishTree.shareLink': '分享链接',
    'wishTree.copyLink': '复制链接',
    'wishTree.copyLinkHint': '复制此链接分享给朋友',
    'wishTree.wishFrom': '许愿者',
    'wishTree.wishType': '愿望类型',
    'wishTree.shareInvitation': '点击查看这个愿望：',
  },
  'zh-TW': {
    'wishTree.title': '許願樹',
    'wishTree.publishWish': '發佈願望',
    'wishTree.wishContent': '願望內容',
    'wishTree.selectStyle': '選擇願望樣式',
    'wishTree.orangeWish': '橙子掛簽',
    'wishTree.appleWish': '蘋果掛簽',
    'wishTree.crystalWish': '水晶掛簽',
    'wishTree.wishPlaceholder': '寫下你的願望...',
    'wishTree.anonymous': '匿名發佈',
    'wishTree.useUsername': '使用用戶名',
    'wishTree.customName': '自定義名稱',
    'wishTree.refresh': '換一批',
    'wishTree.noWishes': '還沒有許願，快寫下你的願望吧！',
    'wishTree.loadingWishes': '載入許願中...',
    'wishTree.wishDetail': '願望詳情',
    'wishTree.publisher': '發佈者',
    'wishTree.publishTime': '發佈時間',
    'wishTree.me': '我',
    'wishTree.anonymousUser': '匿名用戶',
    'common.confirm': '確定',
    'common.cancel': '取消',
    'common.save': '保存',
    'common.close': '關閉',
    'common.loading': '載入中...',
    'auth.login': '登錄',
    'auth.register': '註冊',
    'auth.logout': '退出登錄',
    'auth.account': '用户名/郵箱',
    'auth.username': '用戶名',
    'auth.password': '密碼',
    'auth.email': '郵箱',
    'auth.phone': '手機號',
    'auth.verifyCode': '驗證碼',
    'auth.verifyCode.retry': '秒後重試',
    'auth.sendCode': '發送驗證碼',
    'auth.loginSuccess': '登錄成功！',
    'auth.registerSuccess': '註冊成功！',
    'auth.userCenter': '個人中心',
    'message.publishSuccess': '願望發佈成功！（個人發布超50條會刪除自己發布的最早記錄）',
    'message.publishFailed': '發佈失敗，請稍後重試',
    'message.loginFirst': '請先登錄再發佈願望',
    'message.refreshSuccess': '已為您刷新許願',
    'about.aboutUs': '關於我們',
    'about.contactUs': '聯系我們',
    'about.privacyPolicy': '隱私政策',
    'about.userAgreement': '用戶協議',
    'about.copyRight': '© 2023 許願樹網站. 保留所有權利.',
    'login.userLogin': '用戶登錄',
    'login.userNamePlaceholder': '請輸入用戶名/郵箱',
    'login.passwordPlaceholder': '請輸入密碼',
    'register.userRegister': '用戶註冊',
    'register.userNamePlaceholder': '請輸入用戶名',
    'register.phonePlaceholder': '請輸入手機號',
    'register.emailPlaceholder': '請輸入郵箱',
    'register.emailCode': '驗證碼',
    'register.emailCodePlaceholder': '請輸入郵箱驗證碼',
    'register.confirmPassword': '確認密碼',
    'register.confirmPasswordPlaceholder': '請再次輸入密碼',
    'wishTree.customNamePlaceholder': '請輸入自定義名稱（最多25個字符）',
    'wishTree.customNameHint': '注：自定義名稱將會顯示在願望旁邊，其他用戶可以看到',
    'wishTree.unknownType': '未知類型',
    'validation.requiredAll': '請完成所有必填項',
    'message.editComingSoon': '編輯功能開發中...',
    'message.confirmDelete': '確定要刪除這個願望嗎？',
    'message.deleteSuccess': '刪除成功！',
    'policy.privacyTitle': '隱私政策',
    'policy.userAgreementTitle': '用戶協議',
    'policy.agree': '同意',
    'about.aboutUsMessage': '關於我們：許願樹是一個在線願望分享平台，讓您可以表達和分享美好的願望。',
    'about.contactUsMessage': '聯繫我們：如有任何問題，請發送郵件至 support@wishtree.hk',
    // 验证相关
    'validation.emailRequired': '請輸入郵箱地址',
    'validation.emailFormat': '請輸入正確的郵箱地址',
    'validation.verifyCodeRequired': '請輸入驗證碼',
    'validation.verifyCodeFormat': '驗證碼必須是6位數字',
    'validation.passwordRequired': '請輸入密碼',
    'validation.passwordLength': '密碼長度在6到20個字符',
    'validation.passwordPattern': '密碼必須包含字母和數字',
    'validation.confirmPasswordRequired': '請再次輸入密碼',
    'validation.passwordMatch': '兩次輸入的密碼不一致',
    'validation.phoneRequired': '請輸入手機號',
    'validation.phoneFormat': '手機號格式不正確',
    'validation.usernameRequired': '請輸入用戶名',
    'validation.usernameLength': '用戶名長度在3到20個字符',
    'validation.usernamePattern': '用戶名只能包含字母、數字、下劃線',

    // 忘记密码相关
    'auth.forgotPassword': '忘記密碼',
    'auth.resetPassword': '重置密碼',
    'auth.enterEmail': '請輸入郵箱',
    'auth.newPassword': '新密碼',
    'auth.confirmNewPassword': '確認新密碼',
    'auth.forgotPasswordTitle': '忘記密碼',

    // 消息提示
    'message.codeSent': '驗證碼已發送，請注意查收',
    'message.resetSuccess': '密碼重置成功',
    'message.sendCodeFailed': '發送驗證碼失敗',
    'message.resetFailed': '重置密碼失敗',
    'message.shareToXSuccess': '正在打開X分享頁面...',
    'message.instagramShareHint': '分享內容已複製到剪貼板。如果Instagram應用已打開，請粘貼並分享。',
    'message.instagramAppOpening': '正在打開Instagram應用...',
    'message.instagramAppNotFound': '未檢測到Instagram應用，正在跳轉到應用商店...',
    'message.shareFailed': '分享失敗，請稍後重試',
    'message.copySuccess': '連結已複製到剪貼板',
    'message.copyFailed': '複製失敗，請手動複製',
    'message.wishNotFound': '未找到對應的願望，可能已被刷新',

    //分享相关
    'wishTree.shareWish': '分享願望',
    'wishTree.shareToX': '分享到 X',
    'wishTree.shareToInstagram': '分享到 Instagram',
    'wishTree.shareLink': '分享連結',
    'wishTree.copyLink': '複製連結',
    'wishTree.copyLinkHint': '複製此連結分享給朋友',
    'wishTree.wishFrom': '許願者',
    'wishTree.wishType': '願望類型',
    'wishTree.shareInvitation': '點擊查看這個願望：',

  },
  'en-US': {
    'wishTree.title': 'Wish Tree',
    'wishTree.publishWish': 'Publish Wish',
    'wishTree.wishContent': 'Wish Content',
    'wishTree.selectStyle': 'Select Wish Style',
    'wishTree.orangeWish': 'Orange Wish Card',
    'wishTree.appleWish': 'Apple Wish Card',
    'wishTree.crystalWish': 'Crystal Wish Card',
    'wishTree.wishPlaceholder': 'Write your wish...',
    'wishTree.anonymous': 'Anonymous',
    'wishTree.useUsername': 'Use Username',
    'wishTree.customName': 'Custom Name',
    'wishTree.refresh': 'Refresh',
    'wishTree.noWishes': 'No wishes yet, write yours now!',
    'wishTree.loadingWishes': 'Loading wishes...',
    'wishTree.wishDetail': 'Wish Detail',
    'wishTree.publisher': 'Publisher',
    'wishTree.publishTime': 'Publish Time',
    'wishTree.me': 'Me',
    'wishTree.anonymousUser': 'Anonymous User',
    'common.confirm': 'Confirm',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.logout': 'Logout',
    'auth.account': 'Username/Email',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.email': 'Email',
    'auth.phone': 'Phone',
    'auth.verifyCode': 'Verification Code',
    'auth.verifyCode.retry': 'seconds retry',
    'auth.sendCode': 'Send Code',
    'auth.loginSuccess': 'Login successful!',
    'auth.registerSuccess': 'Registration successful!',
    'auth.userCenter': 'User Center',
    'message.publishSuccess': 'Wish published successfully!(If an individual posts more than 50 items, the earliest records they posted will be deleted.)',
    'message.publishFailed': 'Publish failed, please try again',
    'message.loginFirst': 'Please login first to publish wish',
    'message.refreshSuccess': 'Wishes refreshed!',
    'about.aboutUs': 'About Us',
    'about.contactUs': 'Contact Us',
    'about.privacyPolicy': 'Privacy Policy',
    'about.userAgreement': 'User Agreement',
    'about.copyRight': '© 2023 WishTree Web Site. All Rights Reserved.',
    'login.userLogin': 'User Login',
    'login.userNamePlaceholder': 'Please enter your username/email address.',
    'login.passwordPlaceholder': 'Please enter your password',
    'register.userRegister': 'User Register',
    'register.userNamePlaceholder': 'Please enter your username',
    'register.phonePlaceholder': 'Please enter your phone number',
    'register.emailPlaceholder': 'Please enter your email address',
    'register.emailCode': 'verification code',
    'register.emailCodePlaceholder': 'Please enter your Email verification code',
    'register.confirmPassword': 'Confirm Password',
    'register.confirmPasswordPlaceholder': 'Please enter your password again',
    'wishTree.customNamePlaceholder': 'Please enter custom name (max 25 characters)',
    'wishTree.customNameHint': 'Note: Custom name will be displayed next to the wish, other users can see it',
    'wishTree.unknownType': 'Unknown Type',
    'validation.requiredAll': 'Please complete all required fields',
    'message.editComingSoon': 'Edit feature is under development...',
    'message.confirmDelete': 'Are you sure to delete this wish?',
    'message.deleteSuccess': 'Deleted successfully!',
    'policy.privacyTitle': 'Privacy Policy',
    'policy.userAgreementTitle': 'User Agreement',
    'policy.agree': 'Agree',
    'about.aboutUsMessage': 'About Us: Wish Tree is an online wish-sharing platform that allows you to express and share beautiful wishes.',
    'about.contactUsMessage': 'Contact Us: For any questions, please email support@wishtree.hk',
    // Validation related
    'validation.emailRequired': 'Please enter email address',
    'validation.emailFormat': 'Please enter a valid email address',
    'validation.verifyCodeRequired': 'Please enter verification code',
    'validation.verifyCodeFormat': 'Verification code must be 6 digits',
    'validation.passwordRequired': 'Please enter password',
    'validation.passwordLength': 'Password length between 6 and 20 characters',
    'validation.passwordPattern': 'Password must contain both letters and numbers',
    'validation.confirmPasswordRequired': 'Please enter password again',
    'validation.passwordMatch': 'The two passwords you entered are inconsistent',
    'validation.phoneRequired': 'Please enter phone number',
    'validation.phoneFormat': 'Phone number format is incorrect',
    'validation.usernameRequired': 'Please enter username',
    'validation.usernameLength': 'Username length between 3 and 20 characters',
    'validation.usernamePattern': 'Username can only consist of letters, numbers, underscores',

    // Forgot password related
    'auth.forgotPassword': 'Forgot Password',
    'auth.resetPassword': 'Reset Password',
    'auth.enterEmail': 'Please enter email',
    'auth.newPassword': 'New Password',
    'auth.confirmNewPassword': 'Confirm New Password',
    'auth.forgotPasswordTitle': 'Forgot Password',

    // Messages
    'message.codeSent': 'Verification code sent, please check your email',
    'message.resetSuccess': 'Password reset successful',
    'message.sendCodeFailed': 'Failed to send verification code',
    'message.resetFailed': 'Password reset failed',
    'message.shareToXSuccess': 'Opening X sharing page...',
    'message.instagramShareHint': 'Share content copied to clipboard. If Instagram app opens, please paste and share.',
    'message.instagramAppOpening': 'Opening Instagram app...',
    'message.instagramAppNotFound': 'Instagram app not detected, redirecting to app store...',
    'message.shareFailed': 'Share failed, please try again',
    'message.copySuccess': 'Link copied to clipboard',
    'message.copyFailed': 'Copy failed, please copy manually',
    'message.wishNotFound': 'Wish not found, may have been refreshed',

    // share
    'wishTree.shareWish': 'Share Wish',
    'wishTree.shareToX': 'Share to X',
    'wishTree.shareToInstagram': 'Share to Instagram',
    'wishTree.shareLink': 'Share Link',
    'wishTree.copyLink': 'Copy Link',
    'wishTree.copyLinkHint': 'Copy this link to share with friends',
    'wishTree.wishFrom': 'From',
    'wishTree.wishType': 'Wish Type',
    'wishTree.shareInvitation': 'Check out this wish:',

  }
}

// 当前语言状态
const currentLanguage = ref(localStorage.getItem('language') || 'zh-CN')

// 翻译函数
const t = (key, params = {}) => {
  let message = messages[currentLanguage.value]?.[key] || key

  // 替换参数
  if (params && Object.keys(params).length > 0) {
    Object.keys(params).forEach(param => {
      message = message.replace(`{${param}}`, params[param])
    })
  }

  return message
}

// 设置语言
const setLanguage = (lang) => {
  currentLanguage.value = lang
  localStorage.setItem('language', lang)
  // 触发全局事件，通知组件更新
  window.dispatchEvent(new CustomEvent('language-change', { detail: lang }))
}

// 获取当前语言
const getCurrentLanguage = () => currentLanguage.value

// 获取支持的语言列表
const getLanguages = () => [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'zh-TW', label: '繁體中文' },
  { value: 'en-US', label: 'English' }
]

// Vue 3 插件
const i18nPlugin = {
  install(app) {
    // 提供全局的 $t 函数
    app.config.globalProperties.$t = t
    app.config.globalProperties.$setLanguage = setLanguage
    app.config.globalProperties.$getCurrentLanguage = getCurrentLanguage

    // 提供全局的 $i18n 对象
    app.config.globalProperties.$i18n = {
      t,
      setLanguage,
      getCurrentLanguage,
      getLanguages,
      currentLanguage: readonly(currentLanguage)
    }

    // 也可以提供一个 useI18n 的组合式函数
    app.provide('i18n', {
      t,
      setLanguage,
      getCurrentLanguage,
      getLanguages,
      currentLanguage: readonly(currentLanguage)
    })
  }
}

export default i18nPlugin
